import { add } from "@fluorescent/dom";

// eslint-disable-next-line valid-jsdoc
/**
 * A slide up and fade in reveal animation.
 * Can work on any type of element. Commonly used for subheadings, buttons, and images.
 * @param {Object} node the target element for the animation
 * @param {Object} options optional default overrides
 * @options {String} yStart the starting Y position
 * @options {Number} duration override the default duration
 */
export class FadeUpReveal {
  constructor(node, options = {}) {
    this.node = node;
    this.defaultOpts = {
      yStart: "20px",
      duration: window.theme.animation.duration,
    };
    this.config = { ...this.defaultOpts, ...options };
    this.type = "FadeUpReveal";

    this.gsapImport = import(flu.chunks.gsap).then(({ gsap, CustomEase }) => {
      gsap.registerPlugin(CustomEase);
      this.itemEase = gsap.parseEase(window.theme.animation.ease);
      gsap.set(this.node, { y: this.config.yStart, opacity: 0 });
      add(this.node, "animation-initialized");

      return { gsap };
    });
  }

  init() {
    this.gsapImport.then(({ gsap }) => {
      gsap.set(this.node, { y: this.config.yStart, opacity: 0 });
    });
  }

  play(delay = 0) {
    this.gsapImport.then(({ gsap }) => {
      gsap.to(this.node, {
        y: 0,
        opacity: 1,
        duration: this.config.duration,
        delay: delay,
        ease: this.itemEase,
        onComplete: function () {
          gsap.set(this.targets(), { clearProps: "opacity,y" });
        },
      });
    });
  }
}
